import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

type ClarityFunction = ((...args: unknown[]) => void) & {
  q?: unknown[][];
};

type ClarityWindow = Window & {
  clarity?: ClarityFunction;
};

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  private readonly scriptId = 'microsoft-clarity-script';

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  initialize(projectId: string | null | undefined): void {
    const normalizedProjectId = projectId?.trim();
    const clarityWindow = this.document.defaultView as ClarityWindow | null;

    if (!normalizedProjectId || !clarityWindow || this.document.getElementById(this.scriptId)) {
      return;
    }

    if (!clarityWindow.clarity) {
      const clarity: ClarityFunction = (...args: unknown[]) => {
        (clarity.q ??= []).push(args);
      };

      clarityWindow.clarity = clarity;
    }

    const script = this.document.createElement('script');
    script.id = this.scriptId;
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${encodeURIComponent(normalizedProjectId)}`;

    const firstScript = this.document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
      return;
    }

    this.document.head.appendChild(script);
  }
}
